// @ts-expect-error — @hookform/resolvers v2 subpath export lacks TS types under package.json "exports"
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Flex, Input, Text } from '@rocket/ui';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import { SnackbarCustom } from '../SnackbarCustom';

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/;

const PASSWORD_RULES =
  'Passwords must contain: 1 lower case letter, 1 upper case letter, 1 special character, 1 number, and must be at least 14 characters in length';

const validationSchema = yup.object({
  code: yup.number().typeError('code must be a number').required('This is a required field'),
  email: yup
    .string()
    .max(150, 'Email is too long - should be 150 chars maximum.')
    .email()
    .required('This is a required field'),
  password: yup
    .string()
    .min(14, 'Password is too short - should be 14 chars minimum.')
    .max(25, 'Password is too long - should be 25 chars maximum.')
    .matches(passwordRegex, PASSWORD_RULES)
    .required('This is a required field'),
  confirmPassword: yup
    .string()
    .min(14, 'Password is too short - should be 14 chars minimum.')
    .max(25, 'Password is too long - should be 25 chars maximum.')
    .matches(passwordRegex, PASSWORD_RULES)
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('This is a required field'),
});

interface ResetFormValues {
  code: string;
  email: string;
  password: string;
  confirmPassword: string;
}

interface PasswordResetByCodeProps {
  onClick: () => void;
  setDisplay: (show: boolean) => void;
}

const PasswordResetByCode = ({ onClick: _onClick, setDisplay }: PasswordResetByCodeProps) => {
  const [successMsg, setSuccessMsg] = useState<string | null>(null);
  const [errMsg, setErrMsg] = useState<string | null>(null);

  // TODO: this has been a NO-OP since the Amplify removal — the form validates
  // and then does nothing. Preserved verbatim; wire to the real reset endpoint
  // (Cognito ForgotPassword) or retire the showPasswordReset config flag.
  const handleSubmitVerificationCode = (_values: ResetFormValues) => {
    // Ridding ourselves of legacy auth modules and specifically Amplify
    // Auth.forgotPasswordSubmit(email, code, password)
    //   .then(() => {
    //     // redirect to sign-in page
    //     setSuccessMsg('Password changed successfully');
    //     onClick();
    //   })
    //   .catch((error) => {
    //     setErrMsg('An error occurred');
    //     console.log('An error occurred during password submission:', error);
    //   });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ResetFormValues>({
    defaultValues: { code: '', email: '', password: '', confirmPassword: '' },
    // yup 0.32 types predate the resolver's; runtime contract is identical
    resolver: yupResolver(validationSchema) as never,
    mode: 'onTouched',
  });

  const onSubmit = (values: ResetFormValues) => {
    setTimeout(() => {
      handleSubmitVerificationCode(values);
    }, 400);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
      <Flex.V gap="12px">
        <Text marginBottom="10px">
          Please enter the password reset code you received via email below:
        </Text>
        <Input
          label="Code:"
          type="text"
          autoComplete="off"
          error={errors.code?.message}
          {...register('code')}
        />
        <Input
          label="Email:"
          type="text"
          autoComplete="off"
          error={errors.email?.message}
          {...register('email')}
        />
        <Input
          label="New Password:"
          type="password"
          autoComplete="new-password"
          required
          error={errors.password?.message}
          {...register('password')}
        />
        <Input
          label="Enter New Password Again:"
          type="password"
          autoComplete="new-password"
          required
          error={errors.confirmPassword?.message}
          {...register('confirmPassword')}
        />
        <Flex.H justifyContent="space-between">
          <Button variant="outline" onClick={() => setDisplay(false)}>
            Cancel
          </Button>
          <Button type="submit">Submit</Button>
        </Flex.H>
      </Flex.V>
      <SnackbarCustom severity="warning" msg={errMsg} setMsg={setErrMsg} />
      <SnackbarCustom severity="success" msg={successMsg} setMsg={setSuccessMsg} />
    </form>
  );
};

export default PasswordResetByCode;
